export class DomainProductsModel {

    constructor(public code: string, public name: string) {
    }
}

